import { IEventrParking } from "@eventr/common";
import { useGlobalRouter } from "feat/globalRouter/useGlobalRouter";
import { useMemo } from "react";
import { routes } from "routing";
import { getCategoryProperties } from "utils";
import { useScreenTypeContext } from "../state/screenTypeProvider";
import { useMatchTagsAndUsers } from "./hooks/useMatchTagsAndUsers";
import { ParkingAttachments } from "./parkingComponents/parkingAttachment";
import { ParkingCars } from "./parkingComponents/parkingCars";
import { ParkingHeader } from "./parkingComponents/parkingHeader";
import { ObjectProvider } from "./providers/objectProvider";
import { BaseCard } from "./subComponents/baseCard";
import { RowInfoAddress } from "./subComponents/rowInfoAddress";
import { RowInfoNotes } from "./subComponents/rowInfoNotes";

interface ParkingCardProps {
  id?: string;
  data?: IEventrParking;
  past?: boolean;
  border?: boolean;
}

export default function ParkingCard({ id, data, past }: ParkingCardProps) {
  const { screenType } = useScreenTypeContext();
  const { pushPath } = useGlobalRouter();
  const { matchTagsAndUser } = useMatchTagsAndUsers();

  const teamPage = useMemo(() => {
    if (screenType === "team" || screenType === "teamMember") return true;
    return false;
  }, [screenType]);

  const cars = useMemo(() => {
    if ((data?.cars?.length ?? 0) === 0) {
      return null;
    }
    return data?.cars?.filter((car) => {
      if (
        car?.driver?.find((user) => {
          return matchTagsAndUser(user);
        }) ||
        car?.passengers?.find((user) => {
          return matchTagsAndUser(user);
        })
      ) {
        return true;
      }
      return false;
    });
  }, [data?.cars, matchTagsAndUser]);

  if (!data) return null;

  const handleClick = () => {
    if (data?._id && screenType !== "edit") {
      pushPath(routes.item.parking.build({ itemId: data._id }), { state: { screenType } });
    }
  };
  return (
    <ObjectProvider past={past ?? false} _id={data._id} sectionID="9">
      <BaseCard id={id} past={past} onClick={handleClick}>
        <ParkingHeader
          name={data.parking_name}
          category={getCategoryProperties(data?.categories?.[0])}
          visibility={data.visibility}
        />
        {data.address && <RowInfoAddress address={data.address} />}
        {data.additional_info && <RowInfoNotes notes={data.additional_info} />}
        <ParkingAttachments extra_docs={data.extra_docs} />
        <ParkingCars parkingName={data.parking_name} cars={teamPage ? (data.cars ?? []) : (cars ?? [])} />
      </BaseCard>
    </ObjectProvider>
  );
}
